import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import "../css/SideBarComp.css";
import { getShopDetailsFromLocalStorage } from "../localstorage";

export const SideBarComp = () => {
	const [isOpen, setIsOpen] = useState(false);
	const shopDetails = getShopDetailsFromLocalStorage();
	const toggleSidebar = () => setIsOpen(!isOpen);
	const navigate = useNavigate();

	const logoutUser = () => {
		localStorage.removeItem("shopDetails");
		toggleSidebar();
		navigate("/login-screen", {
			replace: true,
		});
	};

	return (
		<div className="">
			{/* Hamburger Icon */}
			<div className="" onClick={toggleSidebar}>
				<i class="fa-solid fa-bars fa-2x"></i>
			</div>

			{/* Sidebar Component */}
			<div className={`sidebar ${isOpen ? "active" : ""}`}>
				<div className="sidebar-header">
					<h3>Menu</h3>

					<button className="close-btn" onClick={toggleSidebar}>
						<i className="fa-solid fa-xmark"></i>
					</button>
				</div>

				<nav>
					<ul className="sidebar-menu">
						<li>
							<NavLink to="/" onClick={toggleSidebar}>
								<i className="fa-solid fa-house"></i>
								<span>Home</span>
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/contact-support"
								onClick={toggleSidebar}
							>
								<i class="fa-solid fa-headset"></i>
								<span>contact us</span>
							</NavLink>
						</li>
						{shopDetails?.ownerName && (
							<>
								<li>
									<NavLink
										to="/shop-dashboard"
										onClick={toggleSidebar}
									>
										<i className="fa-solid fa-table-columns"></i>
										<span>Dashboard</span>
									</NavLink>
								</li>
								<li>
									<NavLink
										to="/login-screen"
										onClick={toggleSidebar}
									>
										{shopDetails?.ownerName && (
											<>
												<i
													class="fa fa-user"
													aria-hidden="true"
												></i>
												<span>
													{shopDetails?.ownerName}
												</span>
											</>
										)}
									</NavLink>
								</li>
							</>
						)}
						<li>
							{shopDetails?.ownerName ? (
								<span onClick={logoutUser}>
									<i className="fa fa-sign-out"></i>
									<span>Log out</span>
								</span>
							) : (
								<NavLink
									to="/login-screen"
									onClick={toggleSidebar}
								>
									<i className="fa-solid fa-sign-in"></i>
									<span>Login</span>
								</NavLink>
							)}
						</li>
					</ul>
				</nav>
			</div>
			{/* Optional Overlay to close on outside click */}
			{isOpen && (
				<div className="sidebar-overlay" onClick={toggleSidebar}></div>
			)}
		</div>
	);
};
